import {
   VisitContinuouslyUsedMedicinePrescriptionDraftCreateCommand,
   VisitContinuouslyUsedMedicinePrescriptionDraftRemoveCommand,
} from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';

export const useContinuouslyUsedMedicinePrescriptionDraftRemoveCommand = (
   visitId: number,
   medicineId: number,
   onSuccess: () => void
): UseCqrsCommandResult => {
   return useCqrsCommand(
      () => {
         const command = new VisitContinuouslyUsedMedicinePrescriptionDraftRemoveCommand();
         command.visitId = visitId;
         command.medicineId = medicineId;
         return command;
      },
      {
         onSuccess: onSuccess,
      }
   );
};

export const useContinuouslyUsedMedicinePrescriptionDraftCreateCommand = (
   visitId: number,
   medicineId: number,
   patientId: number,
   onSuccess: () => void
): UseCqrsCommandResult => {
   return useCqrsCommand(
      () => {
         const command = new VisitContinuouslyUsedMedicinePrescriptionDraftCreateCommand();
         command.visitId = visitId;
         command.medicineId = medicineId;
         command.patientId = patientId;
         return command;
      },
      {
         onSuccess: onSuccess,
      }
   );
};
